import { render, staticRenderFns } from "./AccountStatus.vue?vue&type=template&id=fd01d3b2&"
import script from "./AccountStatus.vue?vue&type=script&lang=js&"
export * from "./AccountStatus.vue?vue&type=script&lang=js&"
import style0 from "./AccountStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports